import { AgGridReact } from 'ag-grid-react/lib/agGridReact';
import { IcoPlus } from 'icone';
import React, { useContext, useMemo } from 'react';
import { Button } from 'react-bootstrap';
import AG_GRID_LOCALE_IT from '../../ag-grid/locale-it';
import ContinuousReportingActionCell from './ContinuousReportingActionCell';
import { ContinuousReportingType } from '../ContinuousReporting';
import ContinuousReportingCheckCell from './ContinuousReportigCheckCell';
import { columnCentered } from 'lib/helpers/agGridHelpers';
import { UserContext } from 'components/contexts/UserProvider';
interface ContinuousReportingTableProps {
	rowData: ContinuousReportingType[];
	setIsCreateModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
	fetchData: () => void;
	state: 'DRAFT' | 'VALIDATED';
	isEnabledToView: boolean;
	isProjectWp: boolean;
}

const ContinuousReportingTable: React.FC<ContinuousReportingTableProps> = ({
	rowData,
	setIsCreateModalOpen,
	fetchData,
	state,
	isEnabledToView,
	isProjectWp,
}) => {
	const { userAccess, isPartnerUser, isCoordinator } = useContext(UserContext);
	const hasPartnerUserAccess = useMemo(() => (isProjectWp ? isPartnerUser : isCoordinator), [isPartnerUser, isProjectWp, isCoordinator]);
	const localeText = {
		...AG_GRID_LOCALE_IT,
		noRowsToShow: 'Non hai ancora fatto alcun report',
	};
	const columnDefs = [
		{
			headerName: 'Tipo',
			field: 'continuosReportingNumber',
			sortable: true,
		},
		...(state === 'VALIDATED'
			? [
					{
						headerName: 'Inviato',
						field: 'sent',
						cellRenderer: ContinuousReportingCheckCell,
						...columnCentered(),
					},
					{
						headerName: 'Mese Inviato',
						field: 'monthsSentDate',
						...columnCentered(),
						valueGetter: (params: { data: { monthsSentDate: number } }) => {
							if (!params.data.monthsSentDate) return '';
							return 'M' + params.data.monthsSentDate;
						},
					},
					{
						headerName: 'Approvato',
						field: 'approved',
						cellRenderer: ContinuousReportingCheckCell,
						...columnCentered(),
					},
					{
						headerName: 'Mese Approvato',
						field: 'monthsApprovedDate',
						...columnCentered(),
						valueGetter: (params: { data: { monthsApprovedDate: number } }) => {
							if (!params.data.monthsApprovedDate) return '';
							return 'M' + params.data.monthsApprovedDate;
						},
					},
				]
			: []),
		{
			headerName: 'Note',
			field: 'note',
			sortable: true,
			cellStyle: { whiteSpace: 'nowrap' },
		},
	] as const;
	const actionColumn = userAccess.isGuest
		? {
				headerName: '',
				minWidth: 100,
				maxWidth: 100,
				cellRenderer: ContinuousReportingActionCell,
				cellRendererParams: {
					fetchData,
					isEnabledToView: isEnabledToView || hasPartnerUserAccess,
					state,
					isProjectWp,
				},
				resizable: false,
				cellStyle: { textAlign: 'center', padding: 0 },
			}
		: null;

	const defaultColDef = {
		resizable: false,
		wrapText: true,
		autoHeight: true,
		flex: 1,
		suppressMovable: true,
		cellStyle: { padding: '0 1rem' },
	};
	return (
		<>
			{(hasPartnerUserAccess || isEnabledToView) && state === 'DRAFT' && rowData.length > 0 ? (
				<div className="d-flex justify-content-end mb-4">
					<Button onClick={() => setIsCreateModalOpen(true)}>
						<IcoPlus className="light-color ico-small plus new-button" />
						Crea report
					</Button>
				</div>
			) : (
				<div style={{ height: '54px' }} />
			)}
			<div className="ag-theme-alpine list-table">
				<AgGridReact
					rowData={rowData}
					columnDefs={[...columnDefs, ...(actionColumn ? [actionColumn] : [])]}
					defaultColDef={defaultColDef}
					domLayout="autoHeight"
					tooltipShowDelay={0}
					tooltipHideDelay={2000}
					tooltipMouseTrack={true}
					headerHeight={50}
					rowHeight={50}
					suppressCellFocus={true}
					localeText={localeText}
				/>
			</div>
			{(hasPartnerUserAccess || isEnabledToView) && state === 'DRAFT' && rowData.length === 0 ? (
				<div className="d-flex justify-content-center mt-3">
					<Button onClick={() => setIsCreateModalOpen(true)}>
						<IcoPlus className="light-color ico-small plus new-button" />
						Crea report
					</Button>
				</div>
			) : null}
		</>
	);
};

export default ContinuousReportingTable;
